/**
 * AvItemsController
 * Control the selection of the AV items
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 */

angular.module('flsControllers').controller('AvItemsController', [
    '$scope',
    '$window',
    function($scope, $window){

    /**
     * Deinfe AV items
     *
     * @type {Object}
     */
    $scope.avItems = {};

    /**
     * Deinfe requested IDs
     *
     * @type {Object}
     */
    $scope.requested = {
        ids:{}
    };
}]);
